<script setup lang="ts">
import { computed } from 'vue';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

/** Markdown из юридических документов. Пишет админ, но на всякий случай HTML всё равно чистится. */
const props = defineProps<{ source: string }>();

const html = computed(() => DOMPurify.sanitize(marked.parse(props.source, { async: false }) as string));
</script>

<template>
  <div class="prose-legal" v-html="html" />
</template>
